<casa-doc-header></casa-doc-header>
<main
  class="grow flex flex-col"
  [class.app-main-shell]="!wizardShellComponentService.isActive()"
  [class.app-main-shell--immersive]="wizardShellComponentService.isActive()"
>
  <router-outlet></router-outlet>
</main>
